"use client";

import { usePathname } from "next/navigation";

const CTA = () => {
  const pathname = usePathname();
  const shouldShowCTA = ![
    "/privacy-policy",
    "/terms-of-service",
    "/art",
  ].includes(pathname);

  if (!shouldShowCTA) return null;

  return (
    <section className="py-1">
      {/* CTA content commented out */}
    </section>
  );
};

export default CTA;
